module.exports = __webpack_public_path__ + "img/02.f3d44367.png";